import React from 'react';
import numeral from 'numeral';
import LoanInstallmentItemSC, { AlertSC } from './loan-installment-item.styled';
import { SmallText, BodyText } from '../../../typography';
import Mark from '../../../ui/mark';
import dlt from '../../../../utils/default-lang';
import { FormattedMessage } from 'react-intl';

import Moment from 'react-moment';

const LoanInstallmentItem = ({
  date,
  principal,
  status,
  interest,
  total,
  days,
  isTablet,
  price,
  paidDays,
}) => {
  return (
    <LoanInstallmentItemSC>
      <td>
        <div>
          <BodyText className={status === 'late' && days > 12 ? 'bolder red' : 'bolder'}>
            <Moment parse="DD.MM.YYYY" format="DD. MMMM YYYY">
              {date}
            </Moment>
          </BodyText>

          {status === 'late' && days > 12 ? (
            <AlertSC></AlertSC>
          ) : status === 'late' && days <= 12 ? (
            <AlertSC className="black"></AlertSC>
          ) : null}
        </div>

        {isTablet ? (
          <BodyText className={status === 'late' && days > 12 ? 'red' : ''}>
            {numeral(Number(total)).format('0,00.00')} €
          </BodyText>
        ) : null}
      </td>

      {isTablet ? null : (
        <>
          <td>
            <BodyText className={status === 'late' && days > 12 ? 'red' : ''}>
              {numeral(Number(total)).format('0,00.00')} €
            </BodyText>
          </td>
          <td>
            <BodyText className={status === 'late' && days > 12 ? 'red' : ''}>
              {numeral(Number(principal)).format('0,00.00')} €
            </BodyText>
          </td>
          <td>
            <BodyText className={status === 'late' && days > 12 ? 'red' : ''}>
              {numeral(Number(interest)).format('0,00.00')} €
            </BodyText>
          </td>
          <td>
            <BodyText className={paidDays > 0 ? 'red' : 'green'}>
              {paidDays > 0 ? '+' : ''}
              <FormattedMessage
                id="investor_loan_detail_installment_table_head_6_day"
                values={{
                  count: paidDays,
                }}
              />
            </BodyText>
          </td>
        </>
      )}

      <td>
        <SmallText className="bolder">
          <Mark
            colorStyle={
              status === 'late' && days <= 12
                ? 'ORANGE'
                : status === 'pending'
                ? ''
                : status === 'done' || status === 'sale'
                ? 'GREEN'
                : 'RED'
            }
          >
            {status === 'sale' ? (
              <>
                <FormattedMessage id="global_sale" defaultMessage={dlt['global_sale']} /> <br />
                {numeral(Number(price)).format('0,00.00')} €
              </>
            ) : status === 'pending' ? (
              <FormattedMessage
                id="global_pending_to_pay"
                defaultMessage={dlt['global_pending_to_pay']}
              />
            ) : status === 'done' ? (
              <FormattedMessage id="global_paid" defaultMessage={dlt['global_paid']} />
            ) : status === 'late' ? (
              <>
                <FormattedMessage id="global_late" defaultMessage={dlt['global_late']} /> {days}{' '}
                {days === 1 ? (
                  <FormattedMessage id="global_day" defaultMessage={dlt['global_day']} />
                ) : days > 1 && days <= 4 ? (
                  <FormattedMessage
                    id="global_more_days"
                    defaultMessage={dlt['global_more_days']}
                  />
                ) : (
                  <FormattedMessage id="global_days" defaultMessage={dlt['global_days']} />
                )}
              </>
            ) : (
              <FormattedMessage id="global_not_paid" defaultMessage={dlt['global_not_paid']} />
            )}
          </Mark>
        </SmallText>
      </td>
    </LoanInstallmentItemSC>
  );
};

export default LoanInstallmentItem;
